import React from "react";

const About = () => <h1>This is About</h1>;

export default About;
